enum TagStyle {
  SOLID = 'solid',
  OUTLINE = 'outline',
  OUTLINE_WITH_STROKE = 'outline-with-stroke',
}
enum TagWidth {
  FIT_CONTENT = 'fit-content',
  FULL_WIDTH = 'full-width',
}
export { TagStyle, TagWidth };
